import {MSCQ_SELECT_OPTION, MSCQ_SUBMIT} from '../../Redux.constants';
import {selectCheckboxOption} from './SelectCheckboxOption';
import {submitAnswer} from './SubmitAnswer';

export function MSCQReducer(state = {}, action) {
  switch (action.type) {
    case MSCQ_SELECT_OPTION:
      return selectCheckboxOption(state, action.payload);
    case MSCQ_SUBMIT:
      return submitAnswer(state, action.payload);
    default:
      return state;
  }
}
